/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetVaultCashCustomers = () =>
  useQuery<any>({
    queryKey: ["GetVaultCashCustomers"],
    queryFn: () => client(`resources/vaults/customers/cash`),
  });

export const useUpdateCashLimit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`resources/vaults/upsert/insurance/limit`, { data }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetVaultCashCustomers"] });
      },
    },
  });
};

export const useUpdateCustomerCashLimit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`resources/vaults/upsert/customer/cash/limit`, {
        data,
        successMessage: "Customer's cash limit is saved successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetVaultCashCustomers"] });
    },
  });
};

export const useAddCashToVault = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`resources/vaults/add/fit/cash`, {
        data,
        successMessage: "Cash is added to vault successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetVaultCashCustomers"] });
      },
    },
  });
};
